import {useEffect, useState} from "@wordpress/element";
import CartItem from "./CartItem";
import {select, subscribe, useSelect, dispatch} from "@wordpress/data";
import Coupon from "./Coupon";
import ApplyCoupon from "./ApplyCoupon";
const { cartStore } = window.wc.wcBlocksData;

export default function OrderSummary() {

	// Get WC Cart data + re-render on change.
	const cart = useSelect( (select) => {
		const store = select( cartStore );
		return store.getCartData();
	}, [] );

	return (
		<div className="zapc-checkout-order-summary">
			<h3>Your Entries</h3>
			<div className="zapc-checkout-order-summary-table">
				<div className="zapc-checkout-order-summary-table-header">
					<h5>Product</h5>
					<h5>Amount</h5>
					<h5>Qty</h5>
				</div>
				{cart.items.map((item) => ( <CartItem cart_token={false} item={item} key={item.key} /> ) )}
				<div className="zapc-checkout-order-summary-table-footer">
					<div className="zapc-checkout-order-summary-table-footer-total">
						<div>Total</div>
						<div className="zapc-checkout-order-summary-table-footer-total-price">
							{ cart.totals.total_discount && cart.totals.total_discount > 0 && ( <div className="price regular-price"><span className="strikethrough">{cart.totals.currency_prefix + (cart.totals.total_items/100).toFixed(2) }</span></div> ) }
							<div className="price">{cart.totals.currency_prefix + (cart.totals.total_price/100).toFixed(2) }</div>
						</div>
					</div>
					<div className="zapc-checkout-order-summary-table-footer-coupons">
						<ApplyCoupon />
						{cart.coupons && cart.coupons.map((coupon) => ( <Coupon key={coupon.code} coupon={coupon} /> ) )}
					</div>
				</div>
			</div>

		</div>
	);
}